import { render, staticRenderFns } from "./ChatUnreadProvider.vue?vue&type=template&id=5cd120c0"
import script from "./ChatUnreadProvider.vue?vue&type=script&lang=ts"
export * from "./ChatUnreadProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports